export const VERSION = {
  PROD: 'V. 3.3.2',
  QA: 'V. 5.0.0 (QA)',
}
